export default __webpack_public_path__ + "static/media/white-cross.646a0063.svg";